var _path, _path2, _path3, _path4, _path5, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 60,
    viewBox: "0 0 89 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M69.5966 52.8215C63.4852 53.2069 53.4658 53.7395 44.6165 53.7395C35.7672 53.7395 25.7478 53.2069 19.6364 52.8215C19.2742 52.7986 19.2185 53.3312 19.5756 53.387C25.6617 54.333 35.6811 55.6391 44.6139 55.6391C53.5468 55.6391 63.5688 54.333 69.6523 53.387C70.0094 53.3312 69.9537 52.7986 69.5915 52.8215H69.5966Z",
    fill: "url(#paint0_linear_301_2740)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5536 57.6654C58.7642 57.8886 51.2649 58.1752 44.6165 58.1752C37.9681 58.1752 30.4713 57.8861 25.6794 57.6654C25.3173 57.6477 25.2666 58.1802 25.6237 58.2335C30.3953 58.9614 37.8998 59.9099 44.6165 59.9099C51.3333 59.9099 58.8352 58.9614 63.6093 58.2335C63.9664 58.1777 63.9157 57.6477 63.5536 57.6654Z",
    fill: "url(#paint1_linear_301_2740)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9403 42.1267V35.5328C79.9403 18.8757 68.4291 4.91954 52.9467 1.16611C50.2772 0.519401 47.4836 0.182098 44.6191 0.182098C41.7546 0.182098 38.9585 0.519401 36.2865 1.16611C20.8015 4.91701 9.29541 18.8732 9.29541 35.5303V42.1242C4.44274 43.027 1.58838 44.1252 1.58838 45.3095C1.58838 48.3909 20.8547 50.889 44.6191 50.889C68.3835 50.889 87.6499 48.3909 87.6499 45.3095C87.6499 44.1252 84.7955 43.027 79.9428 42.1242L79.9403 42.1267ZM58.311 47.3257C49.0691 47.3257 49.0007 39.2736 49.0007 34.8506C49.0007 29.4437 40.2325 29.4437 40.2325 34.8506C40.2325 39.2736 40.1641 47.3257 30.9222 47.3257C25.3781 47.3257 13.6719 42.9383 13.9455 34.9876C14.219 27.0369 15.4524 22.6494 23.9395 19.9054C32.4292 17.1638 56.8065 17.1638 65.2936 19.9054C73.7833 22.6469 75.0142 27.0344 75.2877 34.9876C75.5612 42.9383 63.8551 47.3257 58.311 47.3257Z",
    fill: "url(#paint2_linear_301_2740)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9394 21.531C32.4291 18.7895 56.8064 18.7895 65.2935 21.531C73.7832 24.2725 75.0141 28.66 75.2876 36.6132C75.5612 44.5639 63.855 48.9514 58.3109 48.9514C49.069 48.9514 49.0006 40.8992 49.0006 36.4763C49.0006 31.0693 40.2324 31.0693 40.2324 36.4763C40.2324 40.8992 40.164 48.9514 30.9221 48.9514C25.378 48.9514 13.6719 44.5639 13.9454 36.6132C14.2189 28.6625 15.4523 24.2751 23.9394 21.531Z",
    fill: "#211C36"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9394 19.8166C32.4291 17.0751 56.8064 17.0751 65.2935 19.8166C73.7832 22.5581 75.0141 26.9456 75.2876 34.8988C75.5612 42.852 63.855 47.237 58.3109 47.237C49.069 47.237 49.0006 39.1848 49.0006 34.7619C49.0006 29.3549 40.2324 29.3549 40.2324 34.7619C40.2324 39.1848 40.164 47.237 30.9221 47.237C25.378 47.237 13.6719 42.8495 13.9454 34.8988C14.2189 26.9481 15.4523 22.5607 23.9394 19.8166Z",
    fill: "url(#paint3_linear_301_2740)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_301_2740",
    x1: 44.6165,
    y1: 60.7062,
    x2: 44.6165,
    y2: -4.49736,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31B4E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#33B4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#3BB6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#49B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#77C3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#96CA82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#BCD25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E6DB33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBE020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_301_2740",
    x1: 44.6165,
    y1: -120.356,
    x2: 44.6165,
    y2: -4.49692,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31B4E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#33B4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_301_2740",
    x1: 44.6166,
    y1: 60.7062,
    x2: 44.6166,
    y2: -4.49701,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31B4E7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#33B4E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#3BB6DC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#49B9CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#5DBDBB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#77C3A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#96CA82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#BCD25D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#E6DB33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBE020"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_301_2740",
    x1: 44.6165,
    y1: 17.316,
    x2: 44.6165,
    y2: 30.6128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBE020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#F2E12A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.07,
    stopColor: "#CEE756"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#ADED7E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#91F2A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#7AF6BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#66F9D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#58FBE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#4DFDF5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#47FEFC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoIcon);
export default __webpack_public_path__ + "static/media/logo-icon.f8270e442e56516f1b8afeaa73eac584.svg";
export { ForwardRef as ReactComponent };